module.exports = __webpack_public_path__ + "img/every_thusday_training_reka.fc8af641.svg";